module.exports = __webpack_public_path__ + "img/logo-login.0719e3b1.svg";